import React from 'react'
import { TableCell, TextField } from '@material-ui/core'

const renderCarrier = ({ id, label }) => <option key={id} value={id}>{label}</option>

export const CarriersSelectCellBase = ({ id, classes, carriers, carrier, onChange, onBlur }) => (
  <TableCell
    numeric
    padding='none'
    className={classes.tableCell}
  >

    <TextField
      select
      value={carrier || ''}
      onBlur={e => onBlur({ id, key: 'carrier', value: e.target.value })}
      padding='none'
      onChange={e => onChange({ id, key: 'carrier', value: e.target.value })}
      InputProps={{
        className: classes.carrierSelect,
      }}
      SelectProps={{
        native: true
      }}
    >
      <option value='' />
      {carriers.map(renderCarrier)}
    </TextField>

  </TableCell>
)



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/CarriersSelectCell/CarriersSelectCell.js